import { useState } from 'react';
import { postTicket } from 'src/lib/utils/utils';
import styles from './contact-us.module.css';
import updateUser from 'src/lib/users/users';
import { useDispatch } from 'react-redux';
import { updateUserData } from 'src/store/action-creators/updateUserAction';
import { AuthState } from 'src/store';
import { useTypedSelector } from 'src/store/hooks';
import { setCookie } from 'src/utils/cookie';

function ContactUsAndFAQ() {
  const dispatch = useDispatch();
  // const [activeTab, setActiveTab] = useState('contactUs');
  // const tabs = [
  //   { id: 'contactUs', name: 'Contact Us' },
  //   { id: 'faq', name: 'FAQ' },
  // ];

  // const setTab = (tab: string) => {
  //   setActiveTab(tab);
  // };

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [success, setSuccessMsg] = useState(false);
  const authState: AuthState = useTypedSelector((state) => state.auth);
  const handleSubmit = (event: any) => {
    event.preventDefault();
    const data = {
      name: name,
      reason: reason,
      email: email,
      description: description,
    };
    submitRequest(data);
  };

  const submitRequest = async (data: any) => {
    const res = await postTicket(data);
    if (res?.status == 1) {
      setName('');
      setEmail('');
      setReason('');
      setDescription('');
      setSuccessMsg(true);
      if (authState.isAuthenticated) {
        updateUserafterSubscribe();
      } else {
        setCookie('isSubscribe', 'true');
      }
    }
  };

  const updateUserafterSubscribe = async () => {
    const userDataReq = {
      'customData.isSubscribe': true,
    };
    await updateUser(userDataReq);
    dispatch(updateUserData());
  };

  return (
    <>
      <div className={`${styles.contactUs}`}>
        <div className="row">
          <div className="col-sm-12">
            <div className={`page-title mt-3 mb-3 mb-md-4 mt-md-4 ${styles.header}`}>
              <h3>Contact us</h3>
            </div>
            <div className="row">
              {/* Left Column: Contact Details Card */}
              <div className="col-lg-5 mb-4 mb-lg-0">
                <div style={{
                  backgroundColor: '#fdf8ec',
                  padding: '30px',
                  borderRadius: '8px',
                  border: '1px solid #d0d0c1',
                  height: '100%'
                }}>
                  <h4 style={{ color: '#838d78', fontFamily: 'new_york_extra_largeregular', marginBottom: '20px' }}>Get in Touch</h4>
                  <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#333333' }}>
                    Have questions about our wines, events, or shipping? Feel free to reach out to us using the form or the contact details below.
                  </p>
                  
                  <div style={{ marginTop: '30px' }}>
                    <div style={{ display: 'flex', marginBottom: '25px', alignItems: 'flex-start' }}>
                      <i className="fa fa-map-marker" style={{ fontSize: '22px', color: '#838d78', width: '30px', marginTop: '4px' }}></i>
                      <div>
                        <strong style={{ display: 'block', fontSize: '16px', color: '#000000', marginBottom: '4px' }}>Our Location</strong>
                        <span style={{ fontSize: '15px', color: '#555555', lineHeight: '1.5' }}>
                          Sommlike<br />
                          407 Main Street<br />
                          Ridgefield, CT 06877
                        </span>
                      </div>
                    </div>

                    <div style={{ display: 'flex', marginBottom: '25px', alignItems: 'flex-start' }}>
                      <i className="fa fa-phone" style={{ fontSize: '20px', color: '#838d78', width: '30px', marginTop: '4px' }}></i>
                      <div>
                        <strong style={{ display: 'block', fontSize: '16px', color: '#000000', marginBottom: '4px' }}>Phone</strong>
                        <span style={{ fontSize: '15px', color: '#555555' }}>
                          <a href="tel:2034702470" style={{ color: '#b25661', textDecoration: 'none', fontWeight: '500' }}>203 470 2470</a>
                        </span>
                      </div>
                    </div>

                    <div style={{ display: 'flex', marginBottom: '25px', alignItems: 'flex-start' }}>
                      <i className="fa fa-envelope" style={{ fontSize: '18px', color: '#838d78', width: '30px', marginTop: '4px' }}></i>
                      <div>
                        <strong style={{ display: 'block', fontSize: '16px', color: '#000000', marginBottom: '4px' }}>Email</strong>
                        <span style={{ fontSize: '15px', color: '#555555' }}>
                          <a href="mailto:hello@sommlike.com" style={{ color: '#b25661', textDecoration: 'none', fontWeight: '500' }}>hello@sommlike.com</a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: Contact Form */}
              <div className="col-lg-7">
                <form onSubmit={handleSubmit}>
                  <div className={`common-form pb-3 ${styles.commonForm}`}>
                    <div className="form-group mb-md-4">
                      <label className={styles.label}>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group mb-md-4">
                      <label className={styles.label}>Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder=""
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={(evt) => evt.key === ' ' && evt.preventDefault()}
                        required
                      />
                    </div>
                    <div className="form-group mb-md-4">
                      <label className={styles.label}>Subject</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group mb-md-4">
                      <label className={styles.label}>Description</label>
                      <textarea
                        className="form-control"
                        style={{ height: '150px' }}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      ></textarea>
                    </div>
                    {success ? <div className={styles.success}>Your request was sent successfully</div> : <></>}
                    <div>
                      <button className={`btn btn-primary w-100 ${styles.submitButton}`} type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUsAndFAQ;
